import { render, staticRenderFns } from "./AdminLeavesLayout.vue?vue&type=template&id=7b94c704&scoped=true&"
import script from "./AdminLeavesLayout.vue?vue&type=script&setup=true&lang=js&"
export * from "./AdminLeavesLayout.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b94c704",
  null
  
)

export default component.exports